module.exports = __webpack_public_path__ + "img/right-arrow.c8a47001.svg";